import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgVeryOilyGlyphSecondary from './svgs/VeryOilyGlyphSecondary.js';
import SvgVeryOilyGlyph from './svgs/VeryOilyGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var veryOilyGlyph = (props => useIcon(SvgVeryOilyGlyph, SvgVeryOilyGlyphSecondary, props));

export { veryOilyGlyph as default };
